import moment from "moment";
import React from "react";
import { formatUnitsForReport, mapUnits } from "../../../../helpers/units";

  export const columnsPurchase = (props,loadPurchaseDetails,selectedRow, selectFilter,dynamicSort) => {
    return  [
          {
            dataField: "item_id",
            hidden: true,
          },
          {
            dataField: "seq_no",
          //   formatter: (cell, row, rowIndex) => {
          //     return rowIndex + 1;
          //   },
            text: props.t("S.N"),
            headerStyle: (colum, colIndex) => {
              return { width: "5%" };
            },
          },
      
          {
            text: props.t("Product"),
            dataField: "name",
            sort: true,
            headerStyle: (colum, colIndex) => {
              return { width: "22%" };
            },
            formatter: (cell, row, rowIndex) => {
              return (
                <span
                  className="text-info mr-2"
                  title="View Details"
                  style={{ cursor: "pointer" }}
                  onClick={() => {                    
                    loadPurchaseDetails(row.product_id);
                  }}
                >
                 {row.name} <span hidden={!row.is_free} className="text-danger" style={{fontSize:"20px"}}>*</span>
                </span>
              );
            },
          },
          // {
          //   text: props.t("Section"),
          //   dataField: "section",
          //   sort: true,
          //   headerStyle: (colum, colIndex) => {
          //     return { width: "10%" };
          //   },
          //   filter: selectFilter({
          //     options: () => {
          //       const unique = [
          //         ...new Map(
          //           [
          //             ...new Set(
          //               selectedRow?.map(({ section: value }) => ({
          //                 value: value,
          //                 label: value,
          //               }))
          //             ),
          //           ].map((item) => [item["value"], item])
          //         ).values(),
          //       ];
      
          //       unique.sort(dynamicSort("label"));
          //       return unique;
          //     },
          //   }),
          // },
          {
            dataField: "name",
            text: props.t("Formula"),
            sort: false,
            formatter: (cell,row)=>{
              return mapUnits(row?.unit_levels)
            },
            headerStyle: (colum, colIndex) => {
              return { width: "14%" };
            },
          },
      
          {
            dataField: "unit",
            text: props.t("Total Received"),
            formatter: (cell, row) => {
              return formatUnitsForReport(row.received_quantity)
            },
            sort: false,
            headerStyle: (colum, colIndex) => {
              return { width: "13%" };
            },
          },
          {
            dataField: "unit_for_cost_price",
            text: props.t("Costing Unit"),
            sort: false,
            headerStyle: (colum, colIndex) => {
              return { width: "10%" };
            },
          },
          // {
          //   dataField: "cost_price",
          //   text: props.t("Price (QR)"),
          //   formatter: (cell,row)=>{
          //     // return row?.cost_price + "/" + row?.unit_for_cost_price
          //     return row?.cost_price 
          //   },
          //   sort: true,
          //   headerStyle: (colum, colIndex) => {
          //     return { width: "10%" };
          //   },
          // },
      
          {
            dataField: "receiving_cost",
            text: props.t("Total Cost (QR)"),
            sort: true,
            formatter: (cell, row, rowIndex) => {
              return Number(row.receiving_cost.toFixed(2));
            },
            headerStyle: (colum, colIndex) => {
              return { width: "6%" };
            },
          },
      
        ];
  }
  export const columnsProductDetails = (props) => {
    return  [
          {
            dataField: "product_id",
            hidden: true,
          },
          {
            dataField: "seq_no",
          //   formatter: (cell, row, rowIndex) => {
          //     return rowIndex + 1;
          //   },
            text: props.t("S.N"),
            headerStyle: (colum, colIndex) => {
              return { width: "5%" };
            },
          },
      
          {
            text: props.t("Product"),
            dataField: "name",
            sort: true,
            headerStyle: (colum, colIndex) => {
              return { width: "22%" };
            }
          },
          {
            dataField: "name",
            text: props.t("Formula"),
            sort: true,
            formatter: (cell,row)=>{
              return mapUnits(row?.unit_levels)
            },
            headerStyle: (colum, colIndex) => {
              return { width: "13%" };
            },
          },
      {
            dataField: "batch",
            text: props.t("Batch"),
            sort: true,
            headerStyle: (colum, colIndex) => {
              return { width: "10%" };
            },
          },
          {
            dataField: "unit",
            text: props.t("Quantity"),
            formatter: (cell, row) => {
              return formatUnitsForReport(row.quantity)
            },
            sort: true,
            headerStyle: (colum, colIndex) => {
              return { width: "13%" };
            },
          },
          {
            dataField: "unit_for_cost_price",
            text: props.t("Costing Unit"),
            sort: true,
            headerStyle: (colum, colIndex) => {
              return { width: "10%" };
            },
          },
      
          {
            dataField: "total_cost",
            text: props.t("Total Cost (QR)"),
            sort: true,
            formatter: (cell, row, rowIndex) => {
              return Number(row.total_cost.toFixed(2));
            },
            headerStyle: (colum, colIndex) => {
              return { width: "6%" };
            },
          },
      
        ];
  }
  export const columnsPurchaseDetails = (props,selectFilter,monthYear )=> {
    return [
        {
          dataField: "_id",
          hidden: true,
        },
        {
          dataField: "delivery_details.seq_no",
        //   formatter: (cell, row, rowIndex) => {
        //     return rowIndex + 1;
        //   },
          text: props.t("S.N"),
          headerStyle: (colum, colIndex) => {
            return { width: "5%" };
          },
        },
        {
          text: props.t("Item"),
          dataField: "delivery_details.name",
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "20%" };
          },
          formatter: (cell, row) => {
            let order_id = row?.order_id;
            const params = `?month=${monthYear}&order_id=${order_id}`;
            return (
              <div>
                <div>{cell}</div>
                 {order_id &&  (
        <small className="ml-1">
          <a
            href={`/finished_products/closed_orders${params}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-info"
          >
            Order: {order_id}
          </a>
        </small>
      )}
              </div>
            );
          }
        },
        {
          dataField: "delivery_details.name",
          text: props.t("Formula"),
          sort: true,
          formatter: (cell,row)=>{
            return mapUnits(row?.delivery_details?.unit_levels)
          },
          headerStyle: (colum, colIndex) => {
            return { width: "13%" };
          },
        },
    
        {
          dataField: "unit",
          text: props.t("Received Quantity"),
          formatter: (cell, row) => {
            return row.delivery_details.is_received ? formatUnitsForReport(row.delivery_details.received_quantity) : "Yet To Receive"
    
          },
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "13%" };
          },
        },
        {
          dataField: "delivery_details.unit_for_cost_price",
          text: props.t("Costing Unit"),
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "10%" };
          },
        },
        {
          dataField: "delivery_details.cost_price",
          text: props.t("Price (QR)"),
           formatter: (cell, row) => {            
              // return row?.delivery_details?.cost_price + "/" + row?.delivery_details?.unit_for_cost_price
              return row?.delivery_details?.cost_price 
          },
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "8%" };
          },
        },
        {
          dataField: "delivery_details.receiving_cost",
          text: props.t("Receiving Cost"),
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "8%" };
          },
        },
        {
          dataField: "receiving_datetime",
          text: props.t("Date"),
          formatter: (cell, row) => {
            return moment(row.receiving_datetime).format("DD/MM/YYYY HH:mm");
          },
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "13%" };
          },
        },
      ];
  }
   export const columnsPurchaseTabDeatils = (props,selectFilter,activeTab )=> {
    return [
        {
          dataField: "row_key",
          hidden: true,
        },
        {
          dataField: "dd_seq_no",
          text: props.t("S.N"),
          headerStyle: (colum, colIndex) => {
            return { width: "5%" };
          },
        },
        {
          text: props.t("Product"),
          dataField: "dd_name",
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "20%" };
          },
           formatter: (cell, row) => {
        return (
          <div>
            <div>{cell}</div>
            {row.po_id  && (
              <small>
                <a
                  href={"/purchase_order?fp_po_id=" + row._id}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-info"
                >
                  PO: {row.po_id}
                </a>
              </small>
            )}
          </div>
        );
      }
        },
        {
          dataField: "dd_name",
          text: props.t("Formula"),
          sort: false,
          formatter: (cell,row)=>{
            return mapUnits(row?.delivery_details?.unit_levels)
          },
          headerStyle: (colum, colIndex) => {
            return { width: "10%" };
          },
        },
     {
      dataField: "dd_is_free",
      text: props.t("Free ?"),
      sort: false,
      hidden:activeTab==2,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
      formatter: (cell) => (cell ? "Yes" : "No"),
      filter: selectFilter({
        options: [
          { value: true, label: "Yes" },
          { value: false, label: "No" },
        ],
         style:{
          height:"25px",
          padding:"0px",
          marginLeft:"10px"
        },
        placeholder: "All",
      }),
    },
        {
          dataField: "unit",
          text: props.t("Quantity"),
          formatter: (cell, row) => {
            return row.delivery_details?.receive?.length ? formatUnitsForReport(row.delivery_details.receive) : "Yet To Receive"
    
          },
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "10%" };
          },
        },
        {
          dataField: "dd_unit_for_cost_price",
          text: props.t("Costing Unit"),
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "10%" };
          },
        },
        {
          dataField: "dd_cost_price",
          text: props.t("Price (QR)"),
           formatter: (cell, row) => {            
              return row?.dd_cost_price 
          },
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "8%" };
          },
        },
        {
          dataField: "dd_receiving_cost",
          text: props.t("Cost"),
            formatter: (cell, row) => {
        if (row?.dd_is_free) {
          return (
            <div>
              <div>Projected: {row?.delivery_details?.projected_cost}</div>
            </div>
          );
        } else {
          return `${row?.dd_receiving_cost}`;
        }
      },
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "8%" };
          },
        },
        {
          dataField: "receiving_datetime",
          text: props.t("Date"),
          formatter: (cell, row) => {
            return moment(row.receiving_datetime).format("DD/MM/YYYY HH:mm");
          },
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "13%" };
          },
        },
      ];
  }
  export const columnsProductOutbound = (props,loadProductOutboundDetails,selectFilter,selectedBranch,dynamicSort) => {    
    return [
  
      {
        dataField: "product_id",
        hidden: true,
      },
      {
        dataField: "seq_no",
      //   formatter: (cell, row, rowIndex) => {
      //     return rowIndex + 1;
      //   },
        text: props.t("S.N"),
        headerStyle: (colum, colIndex) => {
          return { width: "5%" };
        },
      },
  
      {
        text: props.t("Product"),
        dataField: "name",
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: "22%" };
        },
        formatter: (cell, row, rowIndex) => {
          return (
            <span
            className={`${selectedBranch.type ==="Branch" ? `text-info mr-2` : ``}`}
              title="View Details"
              style={{ cursor: "pointer" }}
              onClick={() => {
                if(selectedBranch.type !=="Branch") return
                loadProductOutboundDetails(row.product_id);
              }}
            >
            {row.name}
             </span>
          );
        },
      },
      {
        dataField: "source",
        text: props.t("Source"),
        headerStyle: (colum, colIndex) => {
          return { width: "9%" };
        },
        hidden: selectedBranch.type === "Branch" ? true : false,
      },
      // {
      //   text: props.t("Section"),
      //   dataField: "section",
      //   sort: true,
      //   headerStyle: (colum, colIndex) => {
      //     return { width: "10%" };
      //   },
      //   filter: selectFilter({
      //     options: () => {
      //       const unique = [
      //         ...new Map(
      //           [
      //             ...new Set(
      //               selectedRow?.map(({ section: value }) => ({
      //                 value: value,
      //                 label: value,
      //               }))
      //             ),
      //           ].map((item) => [item["value"], item])
      //         ).values(),
      //       ];
  
      //       unique.sort(dynamicSort("label"));
      //       return unique;
      //     },
      //   }),
      // },
      {
        dataField: "unit_levels",
        text: props.t("Formula"),
        sort: true,
        formatter: (cell,row)=>{
          return mapUnits(row?.unit_levels)
        },
        headerStyle: (colum, colIndex) => {
          return { width: "14%" };
        },
      },
      {
        dataField: "unit",
        text: props.t("Quantity"),
        formatter: (cell, row) => {
          return formatUnitsForReport(row.quantity)
        },
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: "13%" };
        },
      },
      {
        dataField: "unit_for_cost_price",
        text: props.t("Costing Unit"),
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: "10%" };
        },
      },
      // {
      //   dataField: "cost_price",
      //   text: props.t("Price (QR)"),
      //   formatter: (cell,row)=>{
      //     // return row?.cost_price + "/" + row?.unit_for_cost_price
      //     return row?.cost_price 
      //    },
      //   sort: true,
      //   headerStyle: (colum, colIndex) => {
      //     return { width: "10%" };
      //   },
      // },
  
      {
        dataField: "receiving_cost",
        text: props.t("Total Cost (QR)"),
        sort: true,
        formatter: (cell, row, rowIndex) => {
          return Number(row.receiving_cost.toFixed(2));
        },
        headerStyle: (colum, colIndex) => {
          return { width: "6%" };
        },
      }
    ]
  }
  export const columnsProductOutboundDetails = (props,selectFilter,productInboundDetails,dynamicSort) => {
    return [
  
      {
        dataField: "product_id",
        hidden: true,
      },
      {
        dataField: "product_details.seq_no",
      //   formatter: (cell, row, rowIndex) => {
      //     return rowIndex + 1;
      //   },
        text: props.t("S.N"),
        headerStyle: (colum, colIndex) => {
          return { width: "5%" };
        },
      },
  
      {
        text: props.t("Product"),
        dataField: "product_details.name",
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: "21%" };
        }
      },
      {
        dataField: "branch_to.name",
        text: props.t("Branch To"),
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: "14%" };
        },
      },
      {
        dataField: "product_details.name",
        text: props.t("Formula"),
        sort: true,
        formatter: (cell,row)=>{
          return mapUnits(row?.product_details.unit_levels)
        },
        headerStyle: (colum, colIndex) => {
          return { width: "14%" };
        },
      },
      {
        dataField: "product_details.name",
        text: props.t("Quantity"),
        formatter: (cell, row) => {
          return formatUnitsForReport(row.product_details.quantity)
        },
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: "13%" };
        },
      },
      {
        dataField: "product_details.unit_for_cost_price",
        text: props.t("Costing Unit"),
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: "11%" };
        },
      },
      {
        dataField: "product_details.cost_price",
        text: props.t("Price (QR)"),
        formatter: (cell,row)=>{
          // return row?.product_details.cost_price + "/" + row?.product_details.unit_for_cost_price
          return row?.product_details.cost_price 
         },
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: "10%" };
        },
      },
      {
        dataField: "product_details.receiving_cost",
        text: props.t("Total Cost (QR)"),
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: "6%" };
        },
      }
    ]
  }
  export const columnsProductInbound = (props,loadProductInboundDetails,selectFilter,selectedRow,dynamicSort) => {
    return [
  
      {
        dataField: "product_id",
        hidden: true,
      },
      {
        dataField: "seq_no",
      //   formatter: (cell, row, rowIndex) => {
      //     return rowIndex + 1;
      //   },
        text: props.t("S.N"),
        headerStyle: (colum, colIndex) => {
          return { width: "5%" };
        },
      },
  
      {
        text: props.t("Product"),
        dataField: "name",
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: "22%" };
        },
        formatter: (cell, row, rowIndex) => {
          return (
            <span
              className="text-info mr-2"
              title="View Details"
              style={{ cursor: "pointer" }}
              onClick={() => {
                loadProductInboundDetails(row.product_id);
              }}
            >
            {row.name}
              </span>
          );
        },
      },
      // {
      //   text: props.t("Section"),
      //   dataField: "section",
      //   sort: true,
      //   headerStyle: (colum, colIndex) => {
      //     return { width: "10%" };
      //   },
      //   filter: selectFilter({
      //     options: () => {
      //       const unique = [
      //         ...new Map(
      //           [
      //             ...new Set(
      //               selectedRow?.map(({ section: value }) => ({
      //                 value: value,
      //                 label: value,
      //               }))
      //             ),
      //           ].map((item) => [item["value"], item])
      //         ).values(),
      //       ];
  
      //       unique.sort(dynamicSort("label"));
      //       return unique;
      //     },
      //   }),
      // },
      {
        dataField: "unit_levels",
        text: props.t("Formula"),
        sort: true,
        formatter: (cell,row)=>{
          return mapUnits(row?.unit_levels)
        },
        headerStyle: (colum, colIndex) => {
          return { width: "14%" };
        },
      },
      {
        dataField: "unit",
        text: props.t("Quantity"),
        formatter: (cell, row) => {
          return formatUnitsForReport(row.quantity)
        },
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: "13%" };
        },
      },
      {
        dataField: "unit_for_cost_price",
        text: props.t("Costing Unit"),
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: "10%" };
        },
      },
      // {
      //   dataField: "cost_price",
      //   text: props.t("Price (QR)"),
      //   formatter: (cell,row)=>{
      //     // return row?.cost_price + "/" + row?.unit_for_cost_price
      //     return row?.cost_price 
      //    },
      //   sort: true,
      //   headerStyle: (colum, colIndex) => {
      //     return { width: "10%" };
      //   },
      // },
  
      {
        dataField: "receiving_cost",
        text: props.t("Total Cost (QR)"),
        sort: true,
        formatter: (cell, row, rowIndex) => {
          return Number(row.receiving_cost.toFixed(2));
        },
        headerStyle: (colum, colIndex) => {
          return { width: "6%" };
        },
      }
    ]
  }
  export const columnsProductInboundDetails = (props,selectFilter,productOutboundDetails,dynamicSort) => {
    return [
  
      {
        dataField: "product_id",
        hidden: true,
      },
      {
        dataField: "product_details.seq_no",
      //   formatter: (cell, row, rowIndex) => {
      //     return rowIndex + 1;
      //   },
        text: props.t("S.N"),
        headerStyle: (colum, colIndex) => {
          return { width: "5%" };
        },
      },
  
      {
        text: props.t("Product"),
        dataField: "product_details.name",
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: "22%" };
        }
      },
      {
        dataField: "branch_from.name",
        text: props.t("Branch From"),
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: "14%" };
        },
      },
      {
        dataField: "product_details.name",
        text: props.t("Formula"),
        sort: true,
        formatter: (cell,row)=>{
          return mapUnits(row?.product_details.unit_levels)
        },
        headerStyle: (colum, colIndex) => {
          return { width: "14%" };
        },
      },
      {
        dataField: "product_details.name",
        text: props.t("Quantity"),
        formatter: (cell, row) => {
          return formatUnitsForReport(row.product_details.quantity)
        },
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: "13%" };
        },
      },
      {
        dataField: "product_details.unit_for_cost_price",
        text: props.t("Costing Unit"),
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: "10%" };
        },
      },
      {
        dataField: "product_details.cost_price",
        text: props.t("Price (QR)"),
        formatter: (cell,row)=>{
          return row?.product_details.cost_price 
         },
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: "10%" };
        },
      },
  
      {
        dataField: "product_details.receiving_cost",
        text: props.t("Total Cost (QR)"),
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: "6%" };
        },
      }
    ]
  }